import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SectionsUIHelpers";

const SectionsUIContext = createContext();

export function useSectionsUIContext() {
  return useContext(SectionsUIContext);
}

export const SectionsUIConsumer = SectionsUIContext.Consumer;

export function SectionsUIProvider({ sectionsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewSectionPage: sectionsUIEvents.openNewSectionPage,
    openEditSectionPage: sectionsUIEvents.openEditSectionPage
  };

  return (
    <SectionsUIContext.Provider value={value}>
      {children}
    </SectionsUIContext.Provider>
  );
}